import React, { useCallback, useState } from 'react'
import { TextField, Button } from '@material-ui/core'

import './Email.scss'

// Kit (formerly ConvertKit) inline form — see band-bot business/mailing-list.md.
// The form endpoint is public: no API key, Kit handles the opt-in confirmation.
const KIT_FORM_ID = '9934353'
const KIT_ENDPOINT = `https://app.kit.com/forms/${KIT_FORM_ID}/subscriptions`

type Status = 'idle' | 'sending' | 'done' | 'error'

const Email = () => {
  const [email, setEmail] = useState('')
  const [firstName, setFirstName] = useState('')
  const [honeyPot, setHoneyPot] = useState('')
  const [status, setStatus] = useState<Status>('idle')

  const onEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value)
    },
    [],
  )

  const onFirstNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFirstName(e.target.value)
    },
    [],
  )

  const onHoneyPotChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setHoneyPot(e.target.value)
    },
    [],
  )

  const emailValid = email.includes('@') && email.includes('.')
  const canSubmit =
    !!firstName && emailValid && !honeyPot && status !== 'sending'

  const onSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      if (honeyPot) return // bots fill the hidden field; pretend it worked
      setStatus('sending')
      const body = new FormData()
      body.append('email_address', email)
      body.append('fields[first_name]', firstName)
      try {
        const res = await fetch(KIT_ENDPOINT, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        })
        setStatus(res.ok ? 'done' : 'error')
      } catch {
        setStatus('error')
      }
    },
    [email, firstName, honeyPot],
  )

  if (status === 'done') {
    return (
      <div className="email-container">
        <div className="sign-up-text">
          <p>THANKS — CHECK YOUR INBOX TO CONFIRM</p>
        </div>
      </div>
    )
  }

  return (
    <div className="email-container">
      <div className="sign-up-text">
        <p>SUBSCRIBE TO THE ROPE AND LADDER MAILING LIST</p>
      </div>
      <form
        className="flex flex-center input-container"
        onSubmit={onSubmit}
        noValidate
      >
        <TextField
          color="secondary"
          label="First Name"
          margin="dense"
          name="first_name"
          onChange={onFirstNameChange}
          size="small"
          value={firstName}
          variant="filled"
        />
        <TextField
          color="secondary"
          label="Email Address"
          margin="dense"
          name="email_address"
          onChange={onEmailChange}
          size="small"
          type="email"
          value={email}
          variant="filled"
        />
        <div
          style={{ position: 'absolute', left: '-5000px' }}
          aria-hidden="true"
        >
          <input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            value={honeyPot}
            onChange={onHoneyPotChange}
          />
        </div>
        <Button
          color="secondary"
          disabled={!canSubmit}
          variant="contained"
          size="large"
          type="submit"
        >
          {status === 'sending' ? 'Sending…' : 'Subscribe'}
        </Button>
      </form>
      {status === 'error' && (
        <div className="sign-up-text">
          <p>SOMETHING WENT WRONG — TRY AGAIN OR EMAIL JAY@ROPEANDLADDER.COM</p>
        </div>
      )}
    </div>
  )
}

export default Email
